import React from 'react';
import { Routes, Route } from 'react-router-dom'
import './index.css'
import Header from './components/Header' 
import Footer from './components/Footer' 
import Home from './pages/Home'  
import Terms from './pages/Terms'
import PageNotFound from './pages/PageNotFound'

function App() {
  return (
    <div className="appContainer">
      <Header/>
      <div className="mainContent">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<PageNotFound />}/>
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
